import get from 'lodash/get';
import { type Medication } from '~shared/features/my-meds/types';

export const getMedImageURL = (medication: Medication) => {
  const prescriptions = get(medication, 'prescriptions', []);
  const { image_url: imageUrl } = prescriptions.find((rx) => rx.image_url) || {};
  return imageUrl;
};
